export * from './productUnit.enum'

export const initialProductValue = {
    name: "",
    description: "",
    brandId: "",
    categoryId: "",
    hsnCode: undefined,
    variationList: [],
    taxPercentage: undefined,
    imageList: [],
    subCategoryId: "",
    mrp: undefined,
    sellingPrice: undefined,
    purchasePrice: undefined,
    productCode: '',
    stock: {
        productUnit: undefined,
        quantity: undefined,
        stockMinimumQuantity: undefined,
    },
    size: { name: "" },
    weight: { quantity: undefined, unit: "" },
    color: { name: "" },
    flavor: { name: "" },
}